<template>

	<div id="salonImageViewer">

		<div id="imgViewCont" class="container d-flex imgviewer-container">

			<div v-show="index == active_image" v-for="(ph,index) in photos" :key="index" class="row">
				<div class="col-12 imgviewer-imgcontainer">
					<img :src="ph.filename" alt="" class="img-responsive mx-auto">
				</div>
				<div class="col-12 text-center mt-5">
					<div v-if="!hide">
						<btn @click="setPicture('set-home-image',ph.id,1,ph.type)" :class="ph.type == 1 ? 'btn fs-btn danger m-1':'btn fs-btn m-1'">{{ph.type == 1 ? 'ukloni s naslovne':'postavi za naslovnu'}}</btn>
						<btn @click="setPicture('set-profile-image',ph.id,2,ph.type)" :class="ph.type == 2 ? 'btn fs-btn danger m-1':'btn fs-btn m-1'">{{ph.type == 2 ? 'ukloni s profilne':'postavi za profilnu'}}</btn>
						<btn @click="setPicture('set-featured-image',ph.id,3,ph.type)" :class="ph.type == 3 ? 'btn fs-btn danger m-1':'btn fs-btn m-1'">{{ph.type == 3 ? 'ukloni s istaknute':'postavi za istaknutu'}}</btn>
						<btn @click="deleteItem(ph.id)" class="btn fs-btn m-1"><span class="far fa-trash-alt primary-color fa-fw"></span> izbriši</btn>
					</div>
				</div>
			</div>

			<div class="control">
				<div class="clo"><a @click="closeViewer()"><img class="img-responsive" src="../../../assets/images/close.png" alt=""></a></div>
				<div v-if="active_image > 0" class="left"><a @click="slide('left')"><img class="img-responsive" src="../../../assets/images/prev.png" alt=""></a></div>
				<div v-if="active_image < photos.length-1" class="right"><a @click="slide('right')"><img class="img-responsive" src="../../../assets/images/next.png" alt=""></a></div>
			</div>

		</div>

	</div>

</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: "imageViewer",
		props: ['hide'],
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
				photos: (state) => state.photos,
				active_image: (state) => state.active_image,
			})
		},
		data() {
			return {}
		},
		methods: {
			deleteItem(id) {
				if (!confirm("Are you sure you want to delete this photo?")) {
					return false;
				}
				if (this.$store.state.user.salon.photos == null) {
					this.$store.state.user.salon.photos = [];
				}
				this.$store.state.user.salon.photos = this.$store.state.user.salon.photos.filter((d) => d.id != id);

				this.$store.dispatch('get', this.endpoint + 'delete-image/' + id + '?token=' + this.token)
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});

							if (this.active_image < this.user.salon.images.length) {
								this.slide('right');
							} else {
								if (this.active_image > 0) {
									this.slide('left');
								} else {
									this.$store.state.image_viewer = false;
								}
							}
						}
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
					})
			},
			setPicture(endp, id, level, current_type) {
				if (this.$store.state.user.salon.photos == null) {
					this.$store.state.user.salon.photos = [];
				}

				if (level == 3 && current_type != 3) {
					if (this.$store.state.user.salon.images.filter((d) => d.type == 3).length >= 6) {
						alert('you can only set 6 featured photos');
						return false;
					}
				}

				var temp = this.$store.state.user.salon.images.map((d) => {
					if (d.id == id) {
						d.type = d.type == level ? 0 : level;
						console.log(d);
					}
					return d;
				});

				this.$store.state.photos = [];
				this.$store.state.photos = temp;
				this.$store.state.user.salon.photos = temp;
				this.$store.state.user.salon.images = temp;

				this.$store.dispatch('get', this.endpoint + endp + '/' + id + '?token=' + this.token)
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
							this.$store.commit('sortImages');
						}
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
					});
			},
			slide(side) {
				if (side == 'left') {
					if (this.active_image <= 0) {
						this.$store.state.active_image = 0
					} else {
						this.$store.state.active_image -= 1;
					}
				} else {
					if (this.active_image >= this.photos.length - 1) {
						this.$store.state.active_image = this.photos.length - 1
					} else {
						this.$store.state.active_image += 1;
					}
				}
			},
			closeViewer() {
				this.$store.state.image_viewer = false;
			}
		}
	}

</script>

<style>
	.control {
		left: 0;
		right: 0;
	}

	btn {
		color: aliceblue !important;
	}

	.clo {
		position: fixed;
		top: 2em;
		right: 2em;
		width: 1.2em;
		height: auto;
		transform: scale(1.5);
	}

	.left,
	.right {
		width: 2.5em;
		height: auto;
	}

	#salonImageViewer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		margin: auto;
		background: #000000d1;
		z-index: 9999;
	}

	.imgviewer-container {
		padding-top: 3em;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}

</style>
